module.exports = __webpack_public_path__ + "img/noEnglishLogo.41adef71.png";